import React from 'react';
import { Link } from 'react-router-dom'





// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

// import Swiper core and required modules
import SwiperCore, {
     Navigation
} from 'swiper';




// install Swiper modules
SwiperCore.use([Navigation]);






class Proyects extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionOnePro">
                        <svg> <rect></rect> </svg>

                        <div className="titleSectionOnePro">
                            <h1>Proyects</h1>

                        </div>

                        <div className="swiperProyect">

                            <Swiper effect={'coverflow'} loop={true} navigation={true} grabCursor={true} centeredSlides={true} slidesPerView={'auto'} coverflowEffect={{
                                "rotate": 50,
                                "stretch": 0,
                                "depth": 100,
                                "modifier": 1,
                                "slideShadows": true
                            }}  className="mySwiper">
                                <SwiperSlide>
                                    <Link to="/webdevelopment" >
                                        <div className="itemWeb"><div className="cintalu"> <h1 className="itemTitle"> Web development </h1> </div> </div>

                                    </Link>


                                </SwiperSlide>
                                <SwiperSlide>
                                    <Link to="/desktopapp" >


                                        <div className="itemDesktop"><div className="cintalu"> <h1 className="itemTitle"> Desktop apps </h1> </div> </div>
                                    </Link>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <Link to="/bi" >


                                        <div className="itemBI"><div className="cintalu"> <h1 className="itemTitle"> Database and BI </h1> </div>  </div>
                                    </Link>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <Link to="/games" >


                                        <div className="itemGame"><div className="cintalu"> <h1 className="itemTitle"> Video games </h1> </div> </div>
                                    </Link>
                                </SwiperSlide>

                            </Swiper>

                        </div>



                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Proyects;